import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar"; // Adjust the path if necessary
import GoogleReviews from "./GoogleReviews";
import Footer from "./Footer";
import Maps from "./Maps";
import FloatingKontaktButton from "./FloatingKontaktButton";
import DriveClubPromo from "./DriveClubPromo";

const Layout = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  useEffect(() => {
    if (isLandingPage) {
      document.body.classList.add("has-drive-club-banner");
    } else {
      document.body.classList.remove("has-drive-club-banner");
    }

    return () => document.body.classList.remove("has-drive-club-banner");
  }, [isLandingPage]);

  useEffect(() => {
    // Add loaded class to main element when content is ready
    const timer = setTimeout(() => {
      const mainElement = document.querySelector("main");
      if (mainElement) {
        mainElement.classList.add("loaded");
      }
    }, 100); // Small delay to ensure content is rendered

    return () => clearTimeout(timer);
  }, [location.pathname]); // Re-run when route changes

  // Check if we're on a project detail page
  const isProjectGridPage = location.pathname === "/projekte";
  const isProjectDetailPage = location.pathname.startsWith("/projekte/");
  const isBlogPostPage = location.pathname.startsWith("/blog/");
  const isImpressum = location.pathname === "/impressum";
  const isDatenschutz = location.pathname === "/datenschutz";
  const isAGB = location.pathname === "/agb";
  const isContactPage = location.pathname === "/kontakt";
  const isOfferDetailPage = location.pathname.startsWith("/aktuelle-angebote");

  return (
    <div>
      {isLandingPage && <DriveClubPromo />}
      <Navbar />
      <main>
        <Outlet /> {/* This renders the page content based on the route */}
      </main>

      {!isProjectDetailPage &&
        !isProjectGridPage &&
        !isBlogPostPage &&
        !isImpressum &&
        !isDatenschutz &&
        !isAGB &&
        !isContactPage &&
        !isOfferDetailPage && (
          <GoogleReviews
            stickyHeadline="Das sagen unsere Kunden auf Google"
            navbarHeight={70}
          />
        )}

      {/* Only show these components if NOT on project detail page */}
      {!isProjectDetailPage &&
        !isProjectGridPage &&
        !isBlogPostPage &&
        !isImpressum &&
        !isDatenschutz &&
        !isAGB && <Maps />}

      {/* Only show Footer if NOT on blog post page */}
      {!isBlogPostPage && <Footer />}

      {/* Floating Kontakt Button */}
      {!isContactPage && <FloatingKontaktButton />}
    </div>
  );
};

export default Layout;
